import React from "react";
import {
    ButtonPlayPause,
    ButtonQualityOrVolumeContainer,
    ButtonSpeaker,
    CustomReactPlayer,
    Image,
    OverlayPlay,
    OverlayQuality,
    WithoutLogoClassStyle
} from '../../helpers/rendererHelper'
import "./PlayerSmall.css";
import Player from "./Player";

export default class PlayerSmall extends Player {
    render() {
        const {
            author,
            backgroundColor,
            buttonColor,
            defaultVolume,
            display,
            fragment,
            light,
            logo,
            main,
            muted,
            neverPlayed,
            playbackRate,
            playing,
            playlist,
            secondaryColor,
            stream,
            streams,
            title,
            translations,
            unavailableUrl,
            url,
            volume,
            preview
        } = this.state;
        let color = {backgroundColor: this.state.backgroundColor, color: this.state.secondaryColor}

        if (!this.state.stream || !this.state.domainAuthorized) {
            return <div/>;
        }
        document.body.style.backgroundColor = this.state.backgroundColor;

        return <div className='player-wrapper small-player' style={color}>
            <OverlayQuality addTitle={false} streams={streams} stream={stream} main={main}
                            translations={translations} buttonColor={buttonColor} backgroundColor={backgroundColor}
                            onClickClose={this.handleCloseOverlay}
                            load={this.load}/>
            <div id="player-image">
                <OverlayPlay onClick={this.handlePlay} buttonColor={buttonColor}
                             backgroundColor={backgroundColor} visible={neverPlayed}/>
                <Image display={display} onLoad={this.onLoadImage} color={secondaryColor}
                       fadeOut={!neverPlayed ? 'fadeOut' : ''}/>
            </div>
            <div id="player">
                <div id="title-container"><p id="title">{title}</p></div>
                <div id="author-container"><p id="author">{author}</p></div>
                <div id="controls" className={WithoutLogoClassStyle(logo)}>
                    <div id="player-buttons" className="buttons">
                        <ButtonPlayPause
                            onClickPlay={this.handlePlay}
                            onClickPause={this.handlePause}
                            color={buttonColor}
                            playing={playing}
                        />
                        <ButtonSpeaker
                            onClick={this.handleToggleMuted}
                            color={buttonColor}
                            muted={muted}
                        />
                        <ButtonQualityOrVolumeContainer visible={streams.length > 1} color={buttonColor} volume={volume}
                                                        defaultVolume={defaultVolume} onClick={this.handleOpenOverlay}
                                                        onChange={this.handleVolumeChange}/>
                    </div>
                    <div id="logo">
                        <p id="powered-by">by</p>
                        <p id="infomaniak">infomaniak</p>
                    </div>
                </div>

            </div>
            <CustomReactPlayer
                myRef={this.ref}
                url={url}
                playing={playing}
                light={light}
                playbackRate={playbackRate}
                volume={volume}
                muted={muted}
                neverPlayed={neverPlayed}
                playlist={playlist}
                fragment={fragment}
                unavailableUrl={unavailableUrl}
                onReady={this.onPlayerReady}
                onProgress={this.handleProgress}
                setPlayerInError={this.setPlayerInError}
                preview={preview}
            />
        </div>;
    }
}
